// extracted by mini-css-extract-plugin
export var blue = "_41-g";
export var brand = "_41-c";
export var darkGrey = "_41-f";
export var disabled = "_41-6";
export var disabledSubtle = "_41-7";
export var error = "_41-8";
export var green = "_41-h";
export var grey = "_41-e";
export var icon = "_41-0";
export var inherit = "_41-b";
export var lightGrey = "_41-d";
export var orange = "_41-j";
export var pink = "_41-l";
export var primary = "_41-1";
export var purple = "_41-m";
export var quaternary = "_41-4";
export var quinary = "_41-5";
export var red = "_41-k";
export var secondary = "_41-2";
export var success = "_41-a";
export var tertiary = "_41-3";
export var warning = "_41-9";
export var white = "_41-n";
export var yellow = "_41-i";